import { Svg } from "../svg";
import { IconType } from "../../models";

export const IconWhatsapp: IconType = ({ className = "" }) => (
  <Svg className={className} viewBox="0 0 31 31">
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M19.9596 22.4239C16.926 22.316 12.0964 19.9194 8.78675 14.1708C7.61268 12.1265 7.78086 9.79659 9.5039 8.19676C10.0846 7.65395 10.8144 7.78727 11.4998 7.90155C11.668 7.92694 11.8425 8.18406 11.9282 8.37451C12.3693 9.37759 12.804 10.3807 13.188 11.4091C13.391 11.9519 13.0166 12.463 12.2328 13.3677C11.9822 13.6533 11.9314 13.9168 12.125 14.2501C13.3974 16.4054 15.1776 17.964 17.5162 18.8782C17.8589 19.0115 18.1159 18.929 18.3349 18.6592C19.5756 17.1451 19.7025 16.7038 20.353 17.0149C23.4913 18.5163 23.7356 18.5767 23.7515 18.9322C23.8594 21.5764 21.4319 22.5318 19.9627 22.4239H19.9596Z"
      fill="#F8F7F6"
    />
    <path
      d="M4.30465 23.9068L4.40358 23.5633L4.19905 23.2701C2.58766 20.9603 1.64429 18.1497 1.64429 15.1204C1.64429 7.24531 8.02254 0.865234 15.8943 0.865234C23.7667 0.865234 30.1443 7.23564 30.1443 15.1101C30.1443 22.9852 23.766 29.3652 15.8943 29.3652C12.9942 29.3652 10.3025 28.5003 8.05208 27.0159L7.76393 26.8258L7.43214 26.9211L3.07633 28.1717L4.30465 23.9068Z"
      stroke="#F8F7F6"
      stroke-width="1.5"
    />
  </Svg>
);
